module.exports = __webpack_public_path__ + "static/media/sinergi-logo.f80023a3.png";